<template>
  <transition name="update-banner">
    <div v-if="appUpdateState.updateAvailable" class="update-banner">
      <div class="update-banner-text">
        <span class="material-symbols-outlined update-banner-icon">system_update</span>
        <div>
          <p class="update-banner-title">Update available</p>
          <p class="update-banner-subtitle">A new version of Success Boost is ready.</p>
        </div>
      </div>
      <button
        class="update-banner-btn"
        :disabled="appUpdateState.updating"
        @click="applyUpdate"
      >
        <span v-if="appUpdateState.updating" class="update-banner-spinner"></span>
        {{ appUpdateState.updating ? 'Updating…' : 'Update Now' }}
      </button>
    </div>
  </transition>
</template>

<script>
import { appUpdateState, applyUpdate } from '@/services/appUpdate'

export default {
  name: 'AppUpdateBanner',
  data () {
    return { appUpdateState }
  },
  methods: {
    applyUpdate
  }
}
</script>

<style scoped>
.update-banner {
  position: fixed;
  left: 50%;
  bottom: calc(1.25rem + env(safe-area-inset-bottom, 0px));
  transform: translateX(-50%);
  z-index: 10000;
  display: flex;
  align-items: center;
  gap: 1rem;
  width: calc(100% - 2rem);
  max-width: 420px;
  background: linear-gradient(135deg, #003366 0%, #1a4d80 100%);
  color: #fff;
  padding: 0.875rem 1rem;
  border-radius: 14px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.update-banner-text {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  text-align: left;
}

.update-banner-icon {
  margin-right: 0.75rem;
  font-size: 1.5rem;
  flex-shrink: 0;
}

.update-banner-title {
  margin: 0;
  font-size: 0.9rem;
  font-weight: 600;
}

.update-banner-subtitle {
  margin: 0;
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.75);
}

.update-banner-btn {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  background: #DAAA00;
  color: #003366;
  font-weight: 600;
  font-size: 0.8rem;
  padding: 0.5rem 0.9rem;
  border-radius: 9999px;
  border: none;
  cursor: pointer;
  transition: opacity 0.2s, transform 0.2s;
}

.update-banner-btn:hover:not(:disabled) {
  transform: translateY(-1px);
}

.update-banner-btn:disabled {
  opacity: 0.7;
  cursor: default;
}

.update-banner-spinner {
  width: 12px;
  height: 12px;
  border: 2px solid rgba(0, 51, 102, 0.35);
  border-top-color: #003366;
  border-radius: 50%;
  animation: update-banner-spin 0.7s linear infinite;
}

@keyframes update-banner-spin {
  to { transform: rotate(360deg); }
}

.update-banner-enter-active,
.update-banner-leave-active {
  transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.update-banner-enter-from,
.update-banner-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(20px);
}

@media (min-width: 640px) {
  .update-banner {
    left: auto;
    right: 1.25rem;
    bottom: 1.25rem;
    transform: none;
  }

  .update-banner-enter-from,
  .update-banner-leave-to {
    opacity: 0;
    transform: translateY(20px);
  }
}
</style>
